import {elements} from 'dnx-design';

import {createNamespacedHelpers} from "vuex";
const {mapGetters, mapMutations} = createNamespacedHelpers('audienceManager/builder');

export default {
    name: 'checklist-question',
    mixins: [],
    components: {
        'Checkbox': elements.Checkbox
    },
    created() {
        if(!this.questionValue(this.questionId)) {
            this.setQuestionValue([]);
        }
    },
    methods: {
        /**
         * Adds option to our value when true.
         * Removes it when false.
         * @param {String} option The option
         * @param {Boolean} value True for add False for remove
         */
        toggleOption(option, value) {
            //get a copy of the question value to avoid mutating the property directly
            const val =  [...this.questionValue(this.questionId)];

            if(value == false) {
                const index = val.indexOf(option);
                val.splice(index,1); //Remove from value
            } else {
                val.push(option); //Add to value
            }

            this.setQuestionValue(val); //Set question in store
        },
        /**
         * Returns true if given option is in our stored value array.
         * @param {String} option
         */
        checked(option) {
            const value = this.questionValue(this.questionId);
            return value && value.indexOf(option.value) !== -1;
        },
        ...mapMutations({
             setQuestionValue(commit, value) {
                commit('setQuestionValue', {
                    questionId: this.questionId,
                    value: value || []
                });
            }}
        )
    },
    computed: {
        /**
         * @type {Array<{label: string, value: string}>}
         */
        options(){
            return this.questionOptions(this.questionId);
        },
        ...mapGetters(['questionOptions', 'questionValue']),
        ...mapGetters({
            'canEdit': 'canEditAudienceQuestionAnswers'
        })
    },
    props: {
        questionId: {
            type: String,
            //required: true,
            default: 'test-checklist'
        }
    }
};